import React, { Component } from "react";
import { Paper, Table, TableBody, TableCell, TableRow, Typography, Box} from '@mui/material';
import moment from "moment-timezone";
import htmlParser from "he";
import ArrowGreenIcon from 'components/images/arrow_green_right.svg';
import ArrowBlueIcon from 'components/images/arrow_blue_right.svg';
import {stripEmTagFromHtml, stripTrailingQuestionMarkFromHtmlEntity} from "_helpers";
import {Link} from "react-router-dom";
import {Button} from "react-bootstrap";
import Checkbox from '@mui/material/Checkbox';
import {userRoles as roles} from "../../_constants";
import styles from "./Styles.module.css";
import BasicTooltip from "../v2/common/BasicTooltip";


/**
 * @author Okpala Oluchukwu Chioma <oluchukwu@chatdesk>
 */
class SearchMessagesTable extends Component {
    render() {
        const { messages, resultCount, exportCSV, exporting, blacklistCheckedMessages, handleMessageCheck,
          selectedMessages, handleAllMessagesCheck, isAllChecked, showSelectAllCheckbox, blacklistAllMessages } = this.props;
        const zone_name =  moment.tz.guess();
        const timezone = moment.tz(zone_name).zoneAbbr();
        const loggedInUser = JSON.parse(localStorage.getItem("user"));
        const currentUserRoles = loggedInUser && loggedInUser.roles && loggedInUser.roles[0];
        const isBillingAdmin = loggedInUser && currentUserRoles === roles.BILLING_ADMIN_ROLE;

        return (
            <div className="search-messages-table">
                <div className={styles.resultCount}>{resultCount ? resultCount : 0} results</div>
                <Paper className={styles.root}>
                    {messages.length === 0 &&
                    <div className={styles.noMsg}>
                        There are no messages that match your search
                    </div>
                    }
                    {messages.length > 0 &&
                    <Table className={styles.table}>
                        <thead>
                            <TableRow className={styles.tableRow}>
                                <TableCell className={styles.tableCell}>
                                    <Typography className={styles.typography15}>Message</Typography>
                                </TableCell>
                                <TableCell className={styles.w80}>
                                    <Typography className={styles.typography15}>Direction</Typography>
                                </TableCell>
                                <TableCell className={`${styles.tableCell} ${styles.w180}`}>
                                    <Typography className={styles.typography15}>Date</Typography>
                                </TableCell>
                                <TableCell className={`${styles.tableCell} ${styles.w100}`}>
                                  {
                                    showSelectAllCheckbox && <div>
                                      <Checkbox
                                        onChange={handleAllMessagesCheck}
                                        checked={isAllChecked}
                                        sx={
                                          isAllChecked ?
                                            {color: '#003300', padding: "7px"} :
                                            {color: '#c8c8c8', padding: "7px"}
                                        }
                                      />
                                    </div>
                                  }
                                </TableCell>
                            </TableRow>
                        </thead>
                        <TableBody>
                            {messages?.map((message, index) => {
                                let highlightPhrase = stripEmTagFromHtml(message.phrase);
                                let text = htmlParser.decode(stripTrailingQuestionMarkFromHtmlEntity(message.messageText));

                                return (
                                    <TableRow key={index} className={styles.tableRow}>
                                        <BasicTooltip
                                            title={
                                                <Box className={styles.tooltipTitleWrapper}>
                                                    <Typography className={styles.tooltipTypography}>
                                                        {text}
                                                    </Typography>
                                                </Box>
                                            }
                                            placement={'bottom-start'}
                                            enterDelay={700}
                                        >
                                            <TableCell className={styles.tableCell}>
                                                <Link to={`messages/${message.messageId}?platform=trends`} className="btn-link tms-no-underline">
                                                    <Typography className={styles.typography14}>
                                                     <span className="font-14 truncate-string">{highlightPhrase}</span>
                                                    </Typography>
                                                </Link>
                                            </TableCell>
                                        </BasicTooltip>
                                        <TableCell className={`${styles.tableCell} ${styles.w80}`}>
                                            {message.direction === "Outgoing" &&
                                            <span>
                                                <img className="arrow-icon-outgoing" src={ArrowBlueIcon} title="outgoing message" alt="outgoing message" />
                                            </span>
                                            }
                                            {message.direction === "Incoming" &&
                                            <span>
                                                <img className="arrow-icon-incoming" src={ArrowGreenIcon} title="incoming message" alt="incoming message" />
                                            </span>
                                            }
                                        </TableCell>
                                        <TableCell className={`${styles.tableCell} ${styles.w180}`}>
                                            <Typography className={styles.typography14}>
                                                {moment(message.messageDate).format('YYYY MMM DD hh:mm A z')}{timezone}
                                            </Typography>
                                        </TableCell>
                                        <TableCell className={styles.tableCell}>
                                          {message.direction === "Outgoing" && !message.hasDetractor &&
                                            <Checkbox
                                              onChange={handleMessageCheck}
                                              value={message.messageId}
                                              checked={selectedMessages.has(message.messageId)}
                                              sx={ selectedMessages.has(message.messageId) ?
                                                {color: '#003300', padding: "7px"} :
                                                {color: '#c8c8c8', padding: "7px"}
                                              }
                                            />
                                          }
                                          {message.direction === "Outgoing" && message.hasDetractor &&
                                            <div className={styles.blacklisted}>
                                              <span className="font-13 color-grey-mid">Blacklisted</span>
                                              <span className="fa fa-check color-green margin-left-5"/>
                                            </div>
                                          }
                                        </TableCell>
                                    </TableRow>)
                            })}
                        </TableBody>
                    </Table>
                    }
                </Paper>
                {
                    messages.length > 0 &&
                    <Button
                        onClick={blacklistCheckedMessages}
                        className={`btn btn-success font-15 ${styles["blacklistBtn"]}`}
                        type="submit"
                    >
                        Blacklist Selections
                    </Button>
                }
                {
                    messages.length > 0 &&
                    <Button
                        onClick={exportCSV}
                        className={`btn btn-success font-15 ${styles["exportBtn"]}`}
                        type="submit">
                        {exporting ? 'Exporting...' : 'Export'}
                    </Button>
                }

                {(isBillingAdmin && messages.length > 0) &&
                <Button
                    onClick={blacklistAllMessages}
                    className={`btn btn-success font-15 ${styles["blacklistAllBtn"]}`}
                    type="submit">
                    Blacklist All Messages
                </Button>
                }
            </div>
        )
    }
}

export { SearchMessagesTable }